import React, { useEffect, useState, useRef, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LiveLotsDetails from "./components/LiveLotsDetails";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { animateScroll } from "react-scroll";
import SpinnersLoading from "../../loader/SpinnersLoading";
import throttle from "lodash.throttle";
import { initializeSocket } from "../../../helpers/SingletonSocketService";
import { globalContext } from "../../../context/ContextProvider";
import { readSingleLiveIndustryAuction } from "../../../redux/action/liveRoom";
import { calculateRemainingTime, formatTime } from "../../../helpers/helpers";

function LiveRoomForLots() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id, catalogueId } = useParams();
  const isDastop = useMediaQuery({ query: "(min-width: 1550px)" });
  const [lotsNumber, setLotsNumber] = useState(1);
  const { profile } = useSelector((state) => state?.profileStore);
  const { industrySingleAuction, sellerLoading } = useSelector(
    (state) => state.singleAuctionIndustry
  );
  const { setSellerLiveRoomConnection } = useContext(globalContext);
  const lotsContainerRef = useRef(null);
  const lotRefs = useRef({});

  const handleScroll = () => {
    Object.values(lotRefs.current).forEach((section, index) => {
      if (section) {
        const rect = section.getBoundingClientRect();
        if (rect.top >= 0 && rect.top <= window.innerHeight / 1.4) {
          setLotsNumber(index + 1);
        }
      }
    });
  };

  useEffect(() => {
    const throttledScroll = throttle(handleScroll, 200);
    window.addEventListener("scroll", throttledScroll);
    return () => {
      window.removeEventListener("scroll", throttledScroll);
    };
  }, []);

  const scrollToLot = (lotNumber) => {
    const targetLotElement = lotRefs.current[lotNumber];
    if (targetLotElement) {
      targetLotElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      // setLotsNumber(lotNumber);
    }
  };

  useEffect(() => {
    dispatch(readSingleLiveIndustryAuction(id));
  }, [dispatch, id]);

  useEffect(() => {
    animateScroll.scrollToTop({ smooth: true });
  }, []);

  useEffect(() => {
    if (industrySingleAuction?.offers?.length && lotRefs.current[1]) {
      lotRefs.current[1].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      setLotsNumber(1);
    }
  }, [industrySingleAuction]);

  useEffect(() => {
    const socket = initializeSocket();

    socket.on("connect", () => {
      console.log("Connected to socket server");
      socket.emit("joinAuctionRoom", {
        organization: profile?.organization,
        auctionId: id,
      });
      setSellerLiveRoomConnection(false);
    });

    ["update-minimum-bid", "update-starting-price", "timeExtended"].forEach(
      (event) => {
        socket.on(event, () => {
          dispatch(readSingleLiveIndustryAuction(id));
        });
      }
    );

    socket.on("connect_error", (err) => {
      setSellerLiveRoomConnection(true);
      console.log(err);
    });

    return () => {
      console.log("Disconnecting socket");
      socket.emit("leaveAuctionRoom", {
        organization: profile?.organization,
        auctionId: id,
      });
      setSellerLiveRoomConnection(true);
      socket.disconnect();
    };
  }, [id, setSellerLiveRoomConnection, profile, dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      const newRemainingTime = calculateRemainingTime(
        industrySingleAuction?.auctionSchedule?.endingTime
      );

      if (!sellerLoading && formatTime(newRemainingTime) <= "00:00:00") {
        navigate("/");
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [navigate, dispatch, id, industrySingleAuction, sellerLoading]);

  if (sellerLoading) {
    return <SpinnersLoading />;
  }

  return (
    <div className="flex column gap-10px">
      <span className="valign-wrapper gap-1 mt-1">
        <span className={`material-icons pointer`} onClick={() => navigate(-1)}>
          west
        </span>
        <h4 className="margin-0px">Live room</h4>
      </span>
      <div style={{ width: isDastop ? "90%" : "100%", margin: "auto" }}>
        <div
          className={`sticky-header`}
          style={{
            position: "sticky",
            top: !isDastop ? "3.3rem" : "3.3rem",
            zIndex: 1,
            background: "#f8f8f8",
            padding: isDastop
              ? "1rem 1rem 1rem 0rem"
              : "2rem 1rem 1rem -0.01rem",
          }}
        >
          <div className="flex column gap-10px mb-2">
            <p className={`${isDastop ? "font-16px" : "font-18px"}`}>
              Select the Lot number to navigate directly to the Lot.
            </p>

            <span>
              {Array.from(
                { length: industrySingleAuction?.offers?.length },
                (_, i) => i + 1
              ).map((page) => (
                <button
                  key={page}
                  onClick={() => scrollToLot(page)}
                  className={`livelots-nativation ${
                    page === lotsNumber && "cercle-purple white-text"
                  }`}
                >
                  {page}
                </button>
              ))}
            </span>
          </div>

          <button
            className={`button-style pointer white-text font-16px`}
            style={{
              padding: "8px 10px",
              width: "160px",
              backgroundImage: "linear-gradient(to right, #3C0A67 , #6F2DA8)",
            }}
            onClick={() => navigate(`/catalogue-view/${catalogueId}`)}
          >
            View Catalogue
          </button>
        </div>
        <div
          ref={lotsContainerRef}
          className={`flex column mt-4`}
          style={{
            gap: "6rem",
          }}
        >
          {industrySingleAuction?.offers?.map((item, index) => (
            <div
              key={item.id || index}
              ref={(el) => (lotRefs.current[index + 1] = el)}
            >
              <LiveLotsDetails
                liveOfferData={item}
                index={index + 1}
                singleAuctionData={industrySingleAuction}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LiveRoomForLots;
